import React from "react";

interface Props {
  className?: string;
  children: React.ReactNode;
  size?: "h1" | "h2";
}

const SectionHeading: React.FC<Props> = ({
  className,
  children,
  size = "h1",
}: Props) => {
  return (
    <>
      {size === "h1" && (
        <h1 className={`section-header__heading ${className || ""}`}>
          {" "}
          {children}{" "}
        </h1>
      )}
      {size === "h2" && (
        <h2 className={`section-header__heading ${className || ""}`}>
          {" "}
          {children}{" "}
        </h2>
      )}
    </>
  );
};

export default SectionHeading;
